import PropTypes from 'prop-types';
import serialize from 'form-serialize';
import { LOAD_GRAVITY_FIELDS } from './actions';
import PortalApi from '../../services/PortalApi';
import { gtmPush } from '../../components/GoogleTagManager';

export const propTypes = {
	forms: PropTypes.object,
};

export const defaultProps = {
	forms: {}
};

export const mapStateToProps = {
	gravity: (state,action) => {
		switch( action.type ) {
			case LOAD_GRAVITY_FIELDS:
				return {
					...state,
					forms: {
						...state.forms,
						[action.gformId]: action.form,
					}
				};
			default:
				return state;
		}
	}
};

export const mapDispatchToProps = {
	onSubmit: ( gformId, e, controller ) => {
		e.preventDefault();
		return dispatch => {
			const submit = e.target.querySelector('[type="submit"]');
			submit.disabled = true;
			gtmPush({
				Category:'Form',
				Action: 'Submit',
				Label: controller.props.forms[ gformId ].title
			});
			PortalApi.postForm( Object.assign({form_id: gformId},serialize( e.target, 'hash'))).then(response => {
				submit.disabled = false;
				controller.renderFormToElement({
					...controller.props.forms[ gformId ],
					response
				},document.getElementById( 'gform-' + gformId ))
			});
		}
	}
};



// WEBPACK FOOTER //
// ./src/containers/GravityForms/props.js